import { FC } from 'react';
import { SectionCard } from './SectionCard';

interface EnrollmentSummaryProps {
  degreeName?: string;
  degreeType?: string;
}

const degreeTypeLabel = (degreeType?: string): string | undefined => {
  if (!degreeType) return undefined;
  if (degreeType === 'bachelor') return "bachelor's degree";
  if (degreeType === 'master') return "master's degree";
  return `${degreeType} degree`;
};

export const EnrollmentSummary: FC<EnrollmentSummaryProps> = ({ degreeName, degreeType }) => {
  const typeLabel = degreeTypeLabel(degreeType);

  return (
    <SectionCard>
      <div className="flex flex-col gap-3">
        {degreeName ? (
          <h3 className="m-0! [font-family:var(--font-montserrat)]! [font-size:var(--fs-l1)]! font-semibold text-(--neutral-black-NB1000)!">
            Your plan: {degreeName}
            {typeLabel ? ` — a ${typeLabel}` : ''}
          </h3>
        ) : (
          <h3 className="m-0! [font-family:var(--font-montserrat)]! [font-size:var(--fs-l1)]! font-semibold text-(--neutral-black-NB1000)!">
            Start your subscription
          </h3>
        )}

        <p className="m-0! [font-size:var(--fs-p3)]! leading-[150%] text-(--neutral-black-NB700)!">
          {degreeName ? (
            <>
              Your saved course plan already enrolled you in this degree. Complete your payment to
              start studying. There&apos;s a one-time registration fee today, and your monthly
              subscription starts in 30 days. You can cancel anytime.
            </>
          ) : (
            <>
              There&apos;s a one-time registration fee today, and your monthly subscription starts
              in 30 days. You can cancel anytime.
            </>
          )}
        </p>
      </div>
    </SectionCard>
  );
};
